export const enum KeyCodeTypeEnum {
  EnterKey = "Enter",
}
